import { Lock, Mail, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { trpc } from "@/lib/trpc";

export default function InviteOnly() {
  const logoutMutation = trpc.auth.logout.useMutation({
    onSuccess: () => {
      window.location.href = "/login";
    },
  });

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center space-y-6">
        {/* Ícone */}
        <div className="flex justify-center">
          <div className="w-20 h-20 rounded-full bg-[#1a4731]/10 flex items-center justify-center">
            <Lock className="w-9 h-9 text-[#1a4731]" />
          </div>
        </div>

        {/* Título */}
        <div className="space-y-2">
          <h1 className="text-2xl font-bold text-foreground">Acesso restrito</h1>
          <p className="text-muted-foreground text-sm leading-relaxed">
            O Bolso está em fase de testes fechados. Apenas testadores convidados
            podem acessar o sistema neste momento.
          </p>
        </div>

        {/* Instrução */}
        <div className="bg-muted/50 border rounded-xl p-4 text-left space-y-2">
          <div className="flex items-center gap-2 text-sm font-medium">
            <Mail className="w-4 h-4 text-[#1a4731]" />
            <span>Como obter acesso?</span>
          </div>
          <p className="text-sm text-muted-foreground">
            Entre em contato com o administrador do Bolso e solicite que seu
            e-mail seja adicionado à lista de testadores.
          </p>
        </div>

        {/* Botão voltar */}
        <Button
          variant="outline"
          className="w-full"
          onClick={() => logoutMutation.mutate()}
          disabled={logoutMutation.isPending}
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          {logoutMutation.isPending ? "Saindo..." : "Voltar ao login"}
        </Button>
      </div>
    </div>
  );
}
